import React, { useEffect, useState } from "react";
import {
  useAddProductGroupCategory,
  useDeleteProductGroupCategory,
  useProductGroupCategory,
  useUpdateProductGroupCategory,
} from "../../../api/product-group-category/use-product-group-category";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import CategoryList from "./Section/CategoryList";
import Instruction from "./Section/Instruction";

function CategoryPage() {
  const [showInstructions, setShowInstructions] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState({});
  const [imagePreview, setImagePreview] = useState(null);
  const [imageName, setImageName] = useState("");
  const [imageFile, setImageFile] = useState();
  const [catName, setCatName] = useState(selectedCategory?.name ?? "");
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [isViewDetail, setIsViewDetail] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const { data: categories } = useProductGroupCategory();
  const { mutate: addProductGroupCategory } = useAddProductGroupCategory();
  const { mutate: updateProductGroupCategory } =
    useUpdateProductGroupCategory();
  const { mutate: deleteProductGroupCategory } =
    useDeleteProductGroupCategory();

  useEffect(() => {
    setImageName("");
    setImagePreview(null);
  }, [showInstructions]);

  const handleImageUpload = async (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setImagePreview(reader.result);
    };

    setImageName(file?.name);
    setImageFile(file);
  };

  const onCancelAdd = () => {
    setSelectedCategory({});
    setIsAdding(false);
    setIsViewDetail(false);
    setIsEditDetail(false);
    setShowInstructions(true);
  };

  const handleSubmitCategory = (data) => {
    try {
      if (Object.keys(selectedCategory).length === 0) {
        addProductGroupCategory({
          ...data,
          img: imageFile,
        });
      } else {
        updateProductGroupCategory({
          ...data,
          img: imageFile ?? selectedCategory?.img,
          id: selectedCategory?.id,
        });
      }
      setImageFile(null);
      setShowInstructions(true);
      setIsEditDetail(false);
      setIsViewDetail(false);
      setSelectedCategory({});
      setIsAdding(false);
    } catch (error) {}
  };

  const onAddCategory = () => {
    setShowInstructions(false);
    setIsViewDetail(false);
    setIsEditDetail(false);
    setSelectedCategory({});
    setIsAdding(true);
    setCatName("");
  };

  const onCategory = (category_id) => {
    setShowInstructions(false);
    setSelectedCategory(category_id);
    setIsViewDetail(true);
    setCatName(selectedCategory?.name);
  };

  const handleToggleEdit = () => {
    setIsEditDetail(!isEditDetail);
    setIsViewDetail(false);
  };

  const handleDeleteCategory = async (id) => {
    try {
      await deleteProductGroupCategory(id);
      setShowInstructions(!showInstructions);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div>
        <TitlePage title="카테고리" />
        <div className="flex mt-4">
          <p className="text-black w-[15.5rem] text-[14px] font-extrabold">
            카테고리 설정
          </p>
          {!showInstructions && (
            <p className="text-sm font-bold">
              {isEditDetail
                ? "ONEDAY Mall 카테고리 정보 > 정보 변경"
                : isViewDetail
                ? "ONEDAY Mall 카테고리 정보"
                : "ONEDAY Mall 카테고리 추가"}
            </p>
          )}
        </div>
      </div>
      <div className="flex mt-4">
        <CategoryList
          onCategory={onCategory}
          categories={categories}
          showInstructions={showInstructions}
          onAddCategory={onAddCategory}
          isViewDetail={isViewDetail}
          selectedCategory={selectedCategory}
          isAdding={isAdding}
        />

        <Instruction
          showInstructions={showInstructions}
          handleImageUpload={handleImageUpload}
          imagePreview={imagePreview}
          onCancelAdd={onCancelAdd}
          onSubmit={handleSubmitCategory}
          imageName={imageName}
          selectedCategory={selectedCategory}
          isEditDetail={isEditDetail}
          handleToggleEdit={handleToggleEdit}
          handleDeleteCategory={handleDeleteCategory}
          isViewDetail={isViewDetail}
          catName={catName}
          setCatName={setCatName}
        />
      </div>
    </>
  );
}

export default CategoryPage;
